import { useState, useCallback } from "react";
import {
  getContacts,
  deleteContact,
  updateContact,
} from "../API/endpoint";

export const useContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadContacts = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getContacts();
      setContacts(data);
      setError("");
    } catch (err) {
      setError("Erreur lors du chargement des contacts");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleDeleteContact = useCallback(async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce message ?")) {
      try {
        await deleteContact(id);
        await loadContacts();
        setError("");
        return true;
      } catch (err) {
        setError("Erreur lors de la suppression du contact");
        console.error(err);
        return false;
      }
    }
    return false;
  }, [loadContacts]);

  const handleMarkAsRead = useCallback(async (id, lu) => {
    try {
      await updateContact(id, { lu });
      await loadContacts();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors du marquage du message");
      console.error(err);
      return false;
    }
  }, [loadContacts]);

  const newContactsCount = contacts.filter(contact => !contact.lu).length;

  return {
    contacts,
    loading,
    error,
    setError,
    loadContacts,
    handleDeleteContact,
    handleMarkAsRead,
    newContactsCount,
  };
};
